import * as React from 'react';
import StickyNode from 'react-stickynode';

const Sticky = ({ children , top , bottomBoundary , enabled  })=>/*#__PURE__*/ React.createElement(StickyNode, {
        top: top,
        bottomBoundary: bottomBoundary,
        enabled: enabled
    }, children)
;
var Sticky$1 = Sticky;

export { Sticky$1 as default };
//# sourceMappingURL=Sticky.js.map
